// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ae1f5fba","339":"5ef0e3e3","355":"ee269134","389":"bfc7b9e8","440":"c5321fa5","453":"f19a62d3","640":"f2b5f3c0","732":"47336faa","815":"d62f7c3e","977":"35c8846c"}[chunkId] + ".chunk.js";
};